/* eslint-disable import/no-extraneous-dependencies */
import { createBrowserHistory } from 'history';

const globalHistory = createBrowserHistory();

export default globalHistory;
